export const RECEIVE_AUTH_ERROR = 'RECEIVE_AUTH_ERROR'

export const RESET_AUTH_ERROR = 'RESET_AUTH_ERROR'

export const FETCH_AUTH = 'FETCH_AUTH'

export const RECEIVE_AUTH = 'RECEIVE_AUTH'

export const RECEIVE_CONFIRM_PAGE_URL = 'RECEIVE_CONFIRM_PAGE_URL'

export const RECEIVE_AUTH_SLT = 'RECEIVE_AUTH_SLT'

export const RESET_AUTH = 'RESET_AUTH'
